import React from 'react';
import ModalWithAnimation from '../ModalWithAnimation/modalWithAnimation';
import { ModalWithAnimationProps } from '../ModalWithAnimation/modalWithAnimation.types';

const COMPONENT_KEY = 'lightbox';
const DEFAULT_DATA_ATTR = { 'data-testid': COMPONENT_KEY };
const DEFAULT_DATA_ATTR_BACKDROP = {
  'data-testid': `${COMPONENT_KEY}__backdrop`,
};
const DEFAULT_DATA_ATTR_CLOSE_BUTTON = {
  'data-testid': `${COMPONENT_KEY}__close-button`,
};
const DEFAULT_DATA_ATTR_CONTENT = {
  'data-testid': `${COMPONENT_KEY}__content-container`,
};

const Lightbox = ({
  backdropProps = {},
  closeButtonProps = {},
  contentProps = {},
  dataAttr,
  isCentered = true,
  ...props
}: ModalWithAnimationProps) => {
  const { dataAttr: backdropDataAttr, ...restBackdropProps } = backdropProps;
  const combinedBackdropProps = {
    dataAttr: { ...DEFAULT_DATA_ATTR_BACKDROP, ...backdropDataAttr },
    ...restBackdropProps,
  };
  const { dataAttr: closeButtonDataAttr, ...restCloseButtonProps } = closeButtonProps;
  const combinedCloseButtonProps = {
    dataAttr: { ...DEFAULT_DATA_ATTR_CLOSE_BUTTON, ...closeButtonDataAttr },
    ...restCloseButtonProps,
  };
  const { dataAttr: contentDataAttr, ...restContentProps } = contentProps;
  const combinedContentProps = {
    dataAttr: { ...DEFAULT_DATA_ATTR_CONTENT, ...contentDataAttr },
    ...restContentProps,
  };
  const combinedDataAttr = { ...DEFAULT_DATA_ATTR, ...dataAttr };

  return (
    <ModalWithAnimation
      backdropProps={combinedBackdropProps}
      closeButtonProps={combinedCloseButtonProps}
      contentProps={combinedContentProps}
      dataAttr={combinedDataAttr}
      isCentered={isCentered}
      {...props}
    />
  );
};

export default React.memo(Lightbox);
